import INetworkConnectionData from "../networkConnection/NetworkConnectionData";

export interface IConnectFormData {
    ipAddress: string;
    port?: number;
    username: string;
    password: string;
    isFile: boolean;
    isAutoLine: boolean;
    dir: string;
    pollingFrequency: number;
    path:string;
    connectionId: string;
    connectionType: string;
    connectionTypeId: string;
    networkConnection: INetworkConnectionData[];
}

export default class ConnectFormData implements IConnectFormData {
    ipAddress: string;
    port?: number;
    username: string;
    password: string;
    isFile: boolean;
    isAutoLine: boolean;
    dir: string;
    pollingFrequency: number;
    path:string;
    connectionId:string;
    connectionType: string;
    connectionTypeId: string;
    networkConnection: INetworkConnectionData[];

    constructor(ipAddress: string, username: string, password: string, isFile: boolean, isAutoLine: boolean,
        directory: string,pollingFrequency: number,path:string,connectionId:string, connectionType: string, 
        connectionTypeId: string, networkConnection: INetworkConnectionData[], port?: number) {
        this.ipAddress = ipAddress;
        this.port = port;
        this.username = username;
        this.password = password;
        this.isFile = isFile;
        this.isAutoLine = isAutoLine;
        this.dir = directory;
        this.pollingFrequency = pollingFrequency;
        this.path= path;
        this.connectionId =connectionId;
        this.connectionType =connectionType;
        this.connectionTypeId =connectionTypeId;
        this.networkConnection = networkConnection;
    }
}

const defaultConnectFormData = new ConnectFormData("", "", "", false, false, "",0,"","","","",[],0);
export { defaultConnectFormData };
